import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'
import BIKE_ATTRIBUTES from '@/js/helper/bike-attributes.js'

export default {
  TYPE: {
    ...FILTER_CONSTANTS.TYPE,
    ITEM_COLOR: BIKE_ATTRIBUTES.TYPE.ITEM_COLOR,
    ITEM_FILTER_COLOR: BIKE_ATTRIBUTES.TYPE.ITEM_FILTER_COLOR,
    ITEM_WHEEL_SIZE_INCH: BIKE_ATTRIBUTES.TYPE.ITEM_WHEEL_SIZE_INCH,
    EBIKE_ENGINE_MODEL: BIKE_ATTRIBUTES.TYPE.EBIKE_ENGINE_MODEL,
    EBIKE_SYSTEM_BRAND: BIKE_ATTRIBUTES.TYPE.EBIKE_SYSTEM_BRAND,
    PRODUCT_E_BIKE: BIKE_ATTRIBUTES.TYPE.PRODUCT_E_BIKE,
    PRODUCT_MAIN_CATEGORY: BIKE_ATTRIBUTES.TYPE.PRODUCT_MAIN_CATEGORY,
    PRODUCT_BIDEX_COMMODITY_GROUP: BIKE_ATTRIBUTES.TYPE.PRODUCT_BIDEX_COMMODITY_GROUP,
    PRODUCT_VARIANTS_CURRENT: BIKE_ATTRIBUTES.TYPE.PRODUCT_VARIANTS_CURRENT,
    PRODUCT_VARIANTS_OUTLET: BIKE_ATTRIBUTES.TYPE.PRODUCT_VARIANTS_OUTLET,
    ITEM_COASTER_BRAKE: BIKE_ATTRIBUTES.TYPE.ITEM_COASTER_BRAKE,
    PRODUCT_GEAR_TYPE: BIKE_ATTRIBUTES.TYPE.PRODUCT_GEAR_TYPE,
    ITEM_BRAND: BIKE_ATTRIBUTES.TYPE.ITEM_BRAND,
    ITEM_GENDER_FRAME: BIKE_ATTRIBUTES.TYPE.ITEM_GENDER_FRAME,
    ITEM_BATTERY_WATT_HOURS: BIKE_ATTRIBUTES.TYPE.ITEM_BATTERY_WATT_HOURS,
    ARCHIVE_ITEM: BIKE_ATTRIBUTES.TYPE.ARCHIVE_ITEM,
    PRODUCT_SEASON: BIKE_ATTRIBUTES.TYPE.PRODUCT_SEASON,
    ITEM_SUPPLIER: BIKE_ATTRIBUTES.TYPE.ITEM_SUPPLIER,
    ZZCA_CLIENT: BIKE_ATTRIBUTES.TYPE.ZZCA_CLIENT,
    PART_BRAND: BIKE_ATTRIBUTES.TYPE.PART_BRAND,
  },
  DEFAULTS: FILTER_CONSTANTS.DEFAULTS,
  SEARCH_REQUEST: 'SEARCH_REQUEST', // DCWSUPPORTDS-1950
  SEARCH_SKU: 'SEARCH_SKU',
}
